export const boldMixin = {
  props: {
    bold: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    boldClass() {
      return this.bold ? "has-text-weight-bold" : "";
    }
  }
};

export const semiBoldMixin = {
  props: {
    semibold: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    semiboldClass(options = {}) {
      if (!options.hasOwnProperty("ignoreProp")) {
        options.ignoreProp = false;
      }

      return this.semibold || options.ignoreProp
        ? "has-text-weight-semibold"
        : "";
    }
  }
};
